import Provider from "./provider";
import { StoreContext } from "./provider";

export {StoreContext};
export default Provider;